import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { slideDownUp } from '@sukna/shared';
import { CommonModule, NgClass } from '@angular/common';
import { IconCaretsDownComponent } from '@sukna/shared';
import { IconCaretDownComponent } from '@sukna/shared';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HasPermissionDirective } from '@sukna/shared';
import { navMenuList } from '../shared/constants';
import { IconLogoutComponent } from '@sukna/shared';
import { AuthService } from '../core/services/api/auth.service';

@Component({
    selector: 'sidebar',
    templateUrl: './sidebar.html',
    imports: [
        CommonModule,
        NgClass,
        TranslatePipe,
        NgScrollbarModule,
        RouterModule,
        IconCaretsDownComponent,
        HasPermissionDirective,
        IconLogoutComponent
    ],
    animations: [slideDownUp],
})
export class SidebarComponent {
    iconCaretDown = IconCaretDownComponent;

    navMenuList = navMenuList

    active = false;
    store: any;
    activeDropdown: string[] = [];
    parentDropdown: string = '';
    constructor(
        private _authService: AuthService,
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
    ) {
        this.initStore();
    }
    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    ngOnInit() {
        this.setActiveDropdown();
    }

    setActiveDropdown() {
        const selector = document.querySelector('.sidebar ul a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }

    toggleMobileMenu() {
        if (window.innerWidth < 1024) {
            this.storeData.dispatch({ type: 'toggleSidebar' });
        }
    }

    toggleAccordion(name: string, parent?: string) {
        if (this.activeDropdown.includes(name)) {
            this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
        } else {
            this.activeDropdown.push(name);
        }
    }

    handleLogout() {
        this._authService.logout()
    }
}
